/* ==========================================================================
   z1-layout.js — Zero 1 (Sep 2026 design port)
   Header nav + mobile drawer + search toggle, and the AJAX mini-cart.

   Public API
   ----------
   window.Z1Cart.open()            open the mini-cart drawer
   window.Z1Cart.close()           close it
   window.Z1Cart.refresh()         re-read /cart.js, repaint badge + drawer
   window.Z1Cart.add(formElement)  post a z1-atc form to /cart/add.js
   window.Z1Cart.getCart()         last cart object read from /cart.js

   Add-to-cart contract for every other template
   ---------------------------------------------
   <form class="z1-atc" action="/cart/add" method="post">
     <input type="hidden" name="id" value="{{ variant.id }}">
     <input name="quantity" value="1">     <!-- optional -->
     <button type="submit">Add to cart</button>
   </form>
   The whole form is serialised, so properties[...] and <select name="id"> work
   too. With JS off the form posts normally and lands on /cart.
   ========================================================================== */
(function () {
  'use strict';
  if (window.Z1Cart) return;

  var CFG = window.Z1CartConfig || {};
  var MONEY = CFG.moneyFormat || '€{{amount}}';
  var CART_URL = CFG.cartUrl || '/cart';
  var doc = document;
  var body = doc.body;
  var cart = null;

  /* ---------------------------------------------------------------- helpers */
  function $(sel, root) { return (root || doc).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || MONEY;
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    function dec(n, precision, thousands, decimal) {
      if (isNaN(n) || n === null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(ph);
    if (!m) return fmt;
    var value;
    switch (m[1]) {
      case 'amount_no_decimals': value = dec(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = dec(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = dec(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = dec(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = dec(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = dec(cents, 2, "'", '.'); break;
      default: value = dec(cents, 2, ',', '.');
    }
    return fmt.replace(ph, value);
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var toastTimer;
  function toast(msg, isError) {
    var el = $('[data-z1-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('is-err', !!isError);
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, isError ? 5200 : 3200);
  }

  /* ------------------------------------------------------- focus management */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var lastFocus = null;

  function trap(panel, e) {
    if (e.key !== 'Tab') return;
    var items = $$(FOCUSABLE, panel).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === doc.activeElement;
    });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function focusInto(panel) {
    var target = $('[data-z1-mcart-close], [data-z1-drawer-close]', panel) || $(FOCUSABLE, panel);
    if (target) { try { target.focus(); } catch (err) { /* no-op */ } }
  }

  /* =========================================================== sticky header */
  function syncHeaderOffset() {
    var wrap = $('[data-z1-header]');
    if (!wrap) return;
    var section = wrap.closest('[id^="shopify-section-"]');
    if (!section) return;
    var ann = $('[data-z1-ann]', wrap);
    var h = ann ? ann.offsetHeight : 0;
    section.style.top = h ? '-' + h + 'px' : '0px';
  }

  /* ============================================================ consent guard */
  /* Shopify injects #shopify-pc__banner late and the store's WhatsApp bubble
     (z-index 2147483647) paints over its "Manage preferences" link. Flag the
     banner on <body> so z1-layout.css can hide the bubble while it is up. */
  function consentVisible() {
    var b = doc.getElementById('shopify-pc__banner');
    if (!b) return false;
    try {
      var st = window.getComputedStyle(b);
      if (st.display === 'none' || st.visibility === 'hidden' || parseFloat(st.opacity) === 0) return false;
    } catch (err) { /* no-op */ }
    return b.offsetHeight > 0 && b.offsetWidth > 0;
  }
  function syncConsent() {
    var on = consentVisible();
    if (on === body.classList.contains('z1-consent-open')) return;
    body.classList.toggle('z1-consent-open', on);
  }
  function watchConsentNode() {
    var b = doc.getElementById('shopify-pc__banner');
    if (!b || b.z1Watched) return;
    b.z1Watched = true;
    try {
      new MutationObserver(syncConsent).observe(b, {
        attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
      });
    } catch (err) { /* no-op */ }
  }
  function initConsentGuard() {
    watchConsentNode(); syncConsent();
    try {
      new MutationObserver(function () { watchConsentNode(); syncConsent(); })
        .observe(body, { childList: true });
    } catch (err) { /* no-op */ }
    // the banner's own buttons dismiss it without touching <body>'s children
    doc.addEventListener('click', function () { setTimeout(syncConsent, 80); }, true);
    [300, 900, 2000, 4000].forEach(function (t) {
      setTimeout(function () { watchConsentNode(); syncConsent(); }, t);
    });
  }

  /* ============================================================= mobile drawer */
  function openDrawer() {
    var d = $('[data-z1-navdrawer]');
    if (!d) return;
    lastFocus = doc.activeElement;
    body.classList.add('z1-drawer-open');
    $$('[data-z1-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    focusInto(d);
  }
  function closeDrawer() {
    if (!body.classList.contains('z1-drawer-open')) return;
    body.classList.remove('z1-drawer-open');
    $$('[data-z1-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) { try { lastFocus.focus(); } catch (err) { /* no-op */ } }
  }

  /* ========================================================= desktop dropdowns */
  function dropVisible(panel) {
    try { return window.getComputedStyle(panel).visibility === 'visible'; }
    catch (err) { return false; }
  }
  function closeDrops() {
    var n = 0;
    $$('.z1-nav-item.is-open').forEach(function (i) {
      i.classList.remove('is-open');
      var b = $('[data-z1-drop-toggle], .z1-nav-link', i);
      if (b) b.setAttribute('aria-expanded', 'false');
      n++;
    });
    return n;
  }

  /* ================================================================ mini-cart */
  function setBusy(on) {
    var d = $('[data-z1-mcart]');
    if (d) d.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function openCart() {
    var d = $('[data-z1-mcart]');
    if (!d) { window.location.href = CART_URL; return; }
    if (!body.classList.contains('z1-mcart-open')) lastFocus = doc.activeElement;
    closeDrawer();
    body.classList.add('z1-mcart-open');
    d.setAttribute('aria-hidden', 'false');
    focusInto(d);
    refresh();
  }
  function closeCart() {
    if (!body.classList.contains('z1-mcart-open')) return;
    body.classList.remove('z1-mcart-open');
    var d = $('[data-z1-mcart]');
    if (d) d.setAttribute('aria-hidden', 'true');
    if (lastFocus) { try { lastFocus.focus(); } catch (err) { /* no-op */ } }
  }

  function paintBadge(count) {
    $$('[data-z1-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    $$('[data-z1-count-label]').forEach(function (el) {
      el.textContent = count + (count === 1 ? ' item in cart' : ' items in cart');
    });
  }

  function variantLine(item) {
    if (item.product_has_only_default_variant) return '';
    if (item.options_with_values && item.options_with_values.length) {
      return item.options_with_values.map(function (o) { return o.value; }).join(' · ');
    }
    return item.variant_title || '';
  }

  function drawerLineHTML(item) {
    var vl = variantLine(item);
    var img = item.image
      ? '<img class="z1-mline-img" src="' + esc(sized(item.image, 120)) + '" alt="" width="56" height="56" loading="lazy">'
      : '<span class="z1-mline-img" aria-hidden="true"></span>';
    return '<div class="z1-mline" data-z1-line="' + esc(item.key) + '">' +
      img +
      '<div>' +
        '<a class="z1-mline-t" href="' + esc(item.url) + '">' + esc(item.product_title || item.title) + '</a>' +
        (vl ? '<div class="z1-mline-v">' + esc(vl) + '</div>' : '') +
        '<div class="z1-mline-act">' +
          '<span class="z1-cqty">' +
            '<button type="button" class="z1-cqty-btn" data-z1-step="-1" aria-label="Decrease quantity">&minus;</button>' +
            '<input class="z1-cqty-val" type="number" min="0" inputmode="numeric" value="' + item.quantity + '" aria-label="Quantity" data-z1-qty-input>' +
            '<button type="button" class="z1-cqty-btn" data-z1-step="1" aria-label="Increase quantity">+</button>' +
          '</span>' +
          '<button type="button" class="z1-rm" data-z1-remove>Remove</button>' +
        '</div>' +
      '</div>' +
      '<div class="z1-mline-p">' + formatMoney(item.final_line_price != null ? item.final_line_price : item.line_price) + '</div>' +
    '</div>';
  }

  function paintDrawer(c) {
    var bodyEl = $('[data-z1-mcart-body]');
    var footEl = $('[data-z1-mcart-foot]');
    if (!bodyEl) return;
    if (!c || !c.item_count) {
      // Same shape as the empty /cart page: icon, display-type heading, one line, one button.
      bodyEl.innerHTML = '<div class="z1-mcart-empty">' +
        '<svg class="z1-mcart-empty-ic" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false">' +
          '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
          '<path d="M1 1h4l2.7 13h10.5L21 6H6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '<p class="z1-mcart-empty-h">' + esc(CFG.emptyHeading || "Your cart's empty") + '</p>' +
        (CFG.emptyText ? '<p class="z1-mcart-empty-p">' + esc(CFG.emptyText) + '</p>' : '') +
        '<a class="btn btn-solid" href="' + esc(CFG.shopAll || '/collections/all') + '">' + esc(CFG.emptyCta || 'Shop all parts') + '</a></div>';
      if (footEl) footEl.setAttribute('hidden', '');
      return;
    }
    bodyEl.innerHTML = c.items.map(drawerLineHTML).join('');
    if (footEl) {
      footEl.removeAttribute('hidden');
      var sub = $('[data-z1-mcart-sub]', footEl);
      if (sub) sub.textContent = formatMoney(c.total_price);
    }
  }

  function apply(c) {
    cart = c;
    paintBadge(c ? c.item_count : 0);
    paintDrawer(c);
  }

  function getJSON(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Accept': 'application/json' } }, opts || {}))
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) { var e = new Error(j.description || j.message || 'Cart error'); e.data = j; throw e; }
          return j;
        });
      });
  }

  function refresh() {
    return getJSON('/cart.js').then(apply).catch(function () { /* leave the last good state */ });
  }

  function addForm(form) {
    if (!form) return Promise.resolve();
    var btn = form.querySelector('[type="submit"]');
    form.classList.add('is-busy');
    if (btn) btn.setAttribute('disabled', 'disabled');
    setBusy(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Could not add that to the cart.'); throw e; } return j; }); })
      .then(function (line) {
        return refresh().then(function () {
          openCart();
          toast((line.product_title || line.title || 'Item') + ' — added to cart');
        });
      })
      .catch(function (err) { toast(err.message || 'Could not add that to the cart.', true); })
      .then(function () {
        form.classList.remove('is-busy');
        if (btn) btn.removeAttribute('disabled');
        setBusy(false);
      });
  }

  function changeLine(key, quantity) {
    setBusy(true);
    return getJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (c) { apply(c); return refreshCartPage(c); })
      .catch(function (err) { toast(err.message || 'Could not update the cart.', true); })
      .then(function () { setBusy(false); });
  }

  /* ============================================================== cart page */
  function cartPageEl() { return $('[data-z1-cartpage]'); }

  function refreshCartPage(c) {
    var page = cartPageEl();
    if (!page) return Promise.resolve();
    var id = page.getAttribute('data-section-id');
    if (!id) { window.location.reload(); return Promise.resolve(); }
    var wrapper = doc.getElementById('shopify-section-' + id);
    return fetch(CART_URL + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('section'); return r.text(); })
      .then(function (html) {
        if (!wrapper) throw new Error('wrapper');
        wrapper.innerHTML = html;
      })
      .catch(function () { window.location.reload(); });
  }

  var noteTimer;
  function saveNote(value) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      getJSON('/cart/update.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: value })
      }).catch(function () { /* a failed note must never block checkout */ });
    }, 600);
  }

  /* ============================================================== listeners */
  doc.addEventListener('click', function (e) {
    var t = e.target;

    // ---- mobile drawer
    if (t.closest('[data-z1-drawer-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-z1-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }

    // ---- drawer accordions
    var groupBtn = t.closest('[data-z1-navgroup-toggle]');
    if (groupBtn) {
      e.preventDefault();
      var group = groupBtn.closest('[data-z1-navgroup]');
      var wasOpen = group.classList.contains('is-open');
      $$('[data-z1-navgroup].is-open').forEach(function (g) {
        g.classList.remove('is-open');
        var b = $('[data-z1-navgroup-toggle]', g);
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) { group.classList.add('is-open'); groupBtn.setAttribute('aria-expanded', 'true'); }
      return;
    }

    // ---- desktop dropdown opened by a destination-less parent
    var dropBtn = t.closest('[data-z1-drop-toggle]');
    if (dropBtn) {
      e.preventDefault();
      var item = dropBtn.closest('.z1-nav-item');
      var open = item.classList.contains('is-open');
      closeDrops();
      if (!open) { item.classList.add('is-open'); dropBtn.setAttribute('aria-expanded', 'true'); }
      return;
    }

    // ---- desktop dropdown on a parent that also has a destination of its own.
    // A mouse opens it on hover, so by the time the click lands the panel is
    // already visible and the link works normally. A touch screen has no hover,
    // so the first tap opens the panel and the second follows the link.
    var navLink = t.closest('.z1-nav-link');
    if (navLink && navLink.tagName === 'A') {
      var navItem = navLink.closest('.z1-nav-item');
      var panel = navItem && navItem.querySelector('.z1-drop');
      if (panel && !dropVisible(panel)) {
        e.preventDefault();
        closeDrops();
        navItem.classList.add('is-open');
        navLink.setAttribute('aria-expanded', 'true');
        return;
      }
    }

    if (!t.closest('.z1-nav-item')) closeDrops();

    // ---- search toggle
    var searchBtn = t.closest('[data-z1-search-toggle]');
    if (searchBtn) {
      e.preventDefault();
      var shell = searchBtn.closest('.z1');
      var nowOpen = !shell.classList.contains('z1-search-open');
      shell.classList.toggle('z1-search-open', nowOpen);
      searchBtn.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      if (nowOpen) { var input = $('#z1-search-input'); if (input) input.focus(); }
      return;
    }

    // ---- mini-cart
    if (t.closest('[data-z1-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-z1-mcart-close]')) { e.preventDefault(); closeCart(); return; }

    // ---- quantity + remove (mini-cart and cart page share these hooks)
    var step = t.closest('[data-z1-step]');
    if (step) {
      e.preventDefault();
      var lineEl = step.closest('[data-z1-line]');
      if (!lineEl) return;
      var input = $('[data-z1-qty-input]', lineEl);
      var next = Math.max(0, (parseInt(input && input.value, 10) || 0) + parseInt(step.getAttribute('data-z1-step'), 10));
      if (input) input.value = next;
      changeLine(lineEl.getAttribute('data-z1-line'), next);
      return;
    }
    var rm = t.closest('[data-z1-remove]');
    if (rm) {
      e.preventDefault();
      var rmLine = rm.closest('[data-z1-line]');
      if (rmLine) changeLine(rmLine.getAttribute('data-z1-line'), 0);
      return;
    }
  });

  doc.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-z1-qty-input]');
    if (input) {
      var lineEl = input.closest('[data-z1-line]');
      if (!lineEl) return;
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = q;
      changeLine(lineEl.getAttribute('data-z1-line'), q);
    }
  });

  doc.addEventListener('input', function (e) {
    var note = e.target.closest && e.target.closest('[data-z1-note]');
    if (note) saveNote(note.value);
  });

  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.classList && form.classList.contains('z1-atc')) {
      e.preventDefault();
      addForm(form);
    }
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (body.classList.contains('z1-mcart-open')) { closeCart(); return; }
      if (body.classList.contains('z1-drawer-open')) { closeDrawer(); return; }
      var openItem = $('.z1-nav-item.is-open');
      if (openItem) {
        var trigger = $('[data-z1-drop-toggle], .z1-nav-link', openItem);
        closeDrops();
        if (trigger) { try { trigger.focus(); } catch (err) { /* no-op */ } }
        return;
      }
      var openSearch = $('.z1.z1-search-open');
      if (openSearch) {
        openSearch.classList.remove('z1-search-open');
        var b = $('[data-z1-search-toggle]', openSearch);
        if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
      }
      return;
    }
    if (e.key === 'Tab') {
      if (body.classList.contains('z1-mcart-open')) trap($('[data-z1-mcart]'), e);
      else if (body.classList.contains('z1-drawer-open')) trap($('[data-z1-navdrawer]'), e);
    }
  });

  window.addEventListener('resize', syncHeaderOffset);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  /* ================================================================== boot */
  function boot() {
    body.classList.add('z1-shell');
    syncHeaderOffset();
    initConsentGuard();
    // The header badge is server-rendered; sync it once in case the page was
    // served from cache, and prime the drawer so the first open is instant.
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 400); };
    idle(function () { refresh(); });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.Z1Cart = {
    open: openCart,
    close: closeCart,
    refresh: refresh,
    add: addForm,
    change: changeLine,
    getCart: function () { return cart; },
    formatMoney: formatMoney
  };
}());
